import { action, computed, observable } from 'mobx';
import { OauthOptions } from '@/store/engine/types/Auth';
import AuthModule from '@/store/engine/modules/AuthModule';
import createLoggerProxy from '@/store/engine/utils/logger';
import { Store } from '@/store/mainStore';
import StoreModule from '@/store/engine/modules/StoreModule';
import EngineModule from '@/store/engine/modules/EngineModule';
import HPAgentModule from '@/store/engine/modules/HPAgentModule';
import BiometricModule from '@/store/engine/modules/BiometricModule';
import ProfileModule from '@/store/engine/modules/ProfileModule';
import OrderModule from '@/store/engine/modules/OrderModule';
import SavedRxModule from '@/store/engine/modules/SavedRxModule';
import { OpenAPI } from '@/store/engine/openapi/generated';

export default class EngineStore {
	@observable private readonly allowLogs: boolean;
	@observable private readonly s: Store;
	@observable private readonly authOptions?: OauthOptions;

	public auth: AuthModule;
	public store: StoreModule;
	public agent: HPAgentModule;
	public biometric: BiometricModule;
	public profile: ProfileModule;
	public order: OrderModule;
	public savedRx: SavedRxModule;

	constructor(authOptions: OauthOptions, store: Store) {
		this.authOptions = authOptions;
		this.s = store;

		this.allowLogs = process.env.NODE_ENV !== 'production' || window.appConfig.VUE_APP_STACK === 'dev';

		this.auth = this.logger(new AuthModule(authOptions, store));
		this.store = this.logger(new StoreModule(store));
		this.agent = this.logger(new HPAgentModule(store));
		this.biometric = this.logger(new BiometricModule(store));
		this.profile = this.logger(new ProfileModule(store));
		this.order = this.logger(new OrderModule(store));
		this.savedRx = this.logger(new SavedRxModule(store));
	}

	private logger<T extends EngineModule>(module: T) {
		return createLoggerProxy(module);
	}

	@action.bound
	public async setEngineClient(token: string) {
		if (!this.authOptions || !this.authOptions.platformURL) {
			throw new Error('Invalid auth options!');
		}
		OpenAPI.TOKEN = token;
		OpenAPI.BASE = this.authOptions.platformURL;
	}
}
